import { Button, Paper, Grid, Tooltip } from "@material-ui/core";
import * as React from "react";
import { observable, toJS } from "mobx";
import { createStyles, withStyles, WithStyles } from "@material-ui/core/styles";
import { history } from "src/history.js";
import { authStore } from "src/modules/auth";
import { observer } from 'mobx-react';
import { config } from "src/config";

import { AppNavigation } from './AppNavigation';

const styles = createStyles({
  root: {
    padding: "2rem",
  },
  buttonDiv: {
    marginTop: "1rem",
    justifyContent: "center",
    display: "flex",
  },
  button: {
    height: "128px",
    width: "128px",
    marginRight: "24px",
    marginBottom: "24px",
    border: "1px solid #1f1d1d",
    color: "#efefef",
    borderRadius: "64px",
  },
});

@observer
class StyledAppPanel extends React.Component<WithStyles<typeof styles>> {
  constructor(props: any) {
    super(props);
  }

  public getAppLinks = (apps: any) => {
    return apps.map((app: any) => {
      if (app.Active) {
        if (app.app_id === 1) {
          if (app.roles[0].PharmacyQualified === 0) {
            return (
              <Tooltip
                title={'Please complete Pharmacy intro courses on the University App'}
                placement="bottom"
              >
                <div>
                  <Button
                    key={1}
                    style={{
                      backgroundColor: "grey",
                    }}
                    disabled={true}
                    className={this.props.classes.button}
                  // onClick={this.handleClick(app.App.toLowerCase())}
                  >
                    {app.App}
                  </Button>
                </div>

              </Tooltip>

            )
          }
          return (
            <Button
              key={1}
              style={{
                backgroundColor: "#192e5b"
              }}
              className={this.props.classes.button}
              onClick={this.handleClick(app.App.toLowerCase())}
            >
              {app.App}
            </Button>
          )
        }
        return (
          <Button
            key={app.app_id}
            style={{
              backgroundColor: app.app_id === 1 ? "#90C68D" : "#2A2A55",
            }}
            className={this.props.classes.button}
            onClick={this.handleClick(app.App.toLowerCase())}
          >
            {app.App}
          </Button>
        )
      }
      else {
        return null
      }
    })
  }

  public handleClick = (button: string) => () => {

    if (button === 'university') {
      authStore.recordAuthAppLogin(authStore.currentUser.auth_id, 2);
      window.location.replace(
        `${config.BASE_UNIVERSITY_URL}/landing?sessionKey=${authStore.currentUser.SessionKey}`
      );
    }
    else if (button === 'pharmacy') {
      authStore.recordAuthAppLogin(authStore.currentUser.auth_id, 1);
      document.cookie = `verifying_token = ${authStore.currentUser.SessionKey}`;
      window.location.replace(
        `${config.BASE_PHARMACY_URL}/landing?sessionKey=${authStore.currentUser.SessionKey}`
      );
    }
  };

  public render() {
    const { classes } = this.props;


    if (!authStore.loaded) {
      return (
        <div>loading</div>
      )
    }

    const links = this.getAppLinks(authStore.currentUser.Apps)

    const apps = authStore.currentUser.Apps as any;
    return (
        <AppNavigation handleClick={this.handleClick} apps={apps} />  
    );
  }
}

export const AppPanel = withStyles(styles, { withTheme: true })(StyledAppPanel);


// WEBPACK FOOTER //
// ./src/modules/apps/AppPanel.tsx